import styled from "styled-components";
import { useTheme } from "../../context/useThemeContext";

import { FaAngleDown } from "react-icons/fa6";
import useMainStore, { SortNotesBy } from "../../stores/mainStore";
import ToggleIconButton from "../../components/buttons/toggleIconButton";
import { FaSortAmountDown, FaSortAmountUp } from "react-icons/fa";
import { hexToRGBA } from "../../utility/hexToRGB";

const SortByStyled = styled.div`
    padding-top: 5px;
    padding-bottom: 5px;
    .dropdown-content {
        /* opacity: 100%; */
        display: none;
    }
    &:hover {
        .dropdown-content {
            /* opacity: 100%; */
            display: flex;
        }
    }

    .dropdown-item {
        cursor: pointer;
        padding: 2px 8px 2px 8px;
        border-radius: 4px;
    }

    .dropdown-item:hover {
        /* text-decoration: underline; */
        background-color: rgba(255, 255, 255, 0.1);
    }
`;

function SortSelector() {
    const { theme } = useTheme();
    // Notes
    const sortNotesBy = useMainStore((state) => state.data.sortNotesBy);
    const sortNotesNewToOld = useMainStore(
        (state) => state.data.sortNotesNewToOld
    );
    // Folders
    const sortFoldersBy = useMainStore((state) => state.data.sortFoldersBy);
    const sortFoldersNewToOld = useMainStore(
        (state) => state.data.sortFoldersNewToOld
    );
    // Current selected folder
    const selectedFolderID = useMainStore(
        (state) => state.data.selectedFolderID
    );

    function SetSortby(selection: SortNotesBy) {
        // In a folder, so sort the notes
        if (selectedFolderID) {
            useMainStore.getState().set.sortNotesBy(() => selection);
        }
        // Note in a folder, so sort the folders
        else {
            useMainStore.getState().set.sortFoldersBy(() => selection);
        }
    }

    function setSortDirection() {
        // In a folder, so sort the notes
        if (selectedFolderID) {
            useMainStore.getState().set.sortNotesNewToOld((prev) => !prev);
        }
        // Note in a folder, so sort the folders
        else {
            useMainStore.getState().set.sortFoldersNewToOld((prev) => !prev);
        }
    }

    function getSortDirectionIcon() {
        if (selectedFolderID) {
            // In a folder, so sort notes
            return sortNotesNewToOld ? (
                <FaSortAmountUp />
            ) : (
                <FaSortAmountDown />
            );
        } else {
            // not in a folder, so sort folders
            return sortFoldersNewToOld ? (
                <FaSortAmountUp />
            ) : (
                <FaSortAmountDown />
            );
        }
    }

    return (
        <div
            className="h-[34px] w-full text-[12px] flex items-center px-3 pr-1 shrink-0 overflow-hidden text-nowrap gap-1 "
            style={{
                backgroundColor: theme.secondaryHeaderColor,
                color: theme.fontColor[100],
            }}
        >
            <div className="flex flex-1 gap-1 items-center">
                Sort by
                <SortByStyled className="min-w-[90px] flex-1 cursor-pointer ">
                    <span
                        className="flex gap-1 items-center flex-1"
                        style={{
                            color: theme.fontColor[50],
                        }}
                    >
                        {(selectedFolderID ? sortNotesBy : sortFoldersBy) || "Date Created"}
                        <FaAngleDown
                            size={11}
                            className="mb-[2px]"
                            color={theme.fontColor[50]}
                        />
                    </span>
                    <div
                        className="dropdown-content"
                        style={{
                            position: "absolute",
                            flexDirection: "column",
                            backgroundColor: theme.secondaryHeaderColor,
                            color: theme.fontColor[50],
                            padding: "6px",
                            marginLeft: "-14px",
                            paddingTop: "8px",
                            paddingLeft: "6px",
                            paddingRight: "6px",
                            zIndex: 1,
                            gap: "2px",
                            fontSize: "14px",
                            borderRadius: "0 0 5px 5px",
                            marginTop: "4px",
                        }}
                    >
                        <div
                            className="dropdown-item"
                            onClick={() => {
                                SetSortby("Date Created");
                            }}
                        >
                            Date Created
                        </div>
                        <div
                            className="dropdown-item"
                            onClick={() => {
                                SetSortby("Date Updated");
                            }}
                        >
                            Date Updated
                        </div>
                        <div
                            className="dropdown-item"
                            onClick={() => {
                                SetSortby("Title");
                            }}
                        >
                            Title
                        </div>
                    </div>
                </SortByStyled>
                <div className="flex flex-1" />
                <ToggleIconButton
                    alt="Sort direction"
                    size={{ x: 24, y: 24 }}
                    iconSize={12}
                    icon={getSortDirectionIcon()}
                    inactiveIconColor={theme.fontColor[100]}
                    hoverIconInactive={theme.fontColor[50]}
                    hoverBGInactive={hexToRGBA(theme.accentColor, 0.2)}
                    onClick={() => {
                        setSortDirection();
                    }}
                />
            </div>
        </div>
    );
}

export default SortSelector;
